import { Component, OnInit, isDevMode } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  topbarTheme: string = 'white';

  menuTheme: string = environment.menuTheme;

  layoutMode: string = 'light';

  menuMode: string = 'static';

  inlineMenuPosition: string = 'bottom';

  inputStyle: string = 'filled';

  ripple: boolean = true;

  isRTL: boolean = false;

  subscription: Subscription;

  /**
   * This constructor initializes the PrimeNGConfig and TranslateService, adds languages to the
   * TranslateService, sets the default language based on the browser language, and subscribes to the
   * translation stream to set the translation data in the PrimeNGConfig.
   * @param {PrimeNGConfig} primeNGConfig - The `primeNGConfig` parameter is an instance of the
   * `PrimeNGConfig` class. It is used to configure and customize the PrimeNG library.
   * @param {TranslateService} translate - The `translate` parameter is an instance of the
   * `TranslateService` class. It is used for managing translations in the application. It provides
   * methods for adding languages, setting default language, and switching between languages. It also
   * provides a `stream` method for subscribing to translation changes.
   */
  constructor(private primeNGConfig: PrimeNGConfig) {

  }

  /**
   * The ngOnInit function sets the ripple property of the primeNGConfig to true and logs whether the
   * application is in development or production mode.
   */
  ngOnInit() {
    this.primeNGConfig.ripple = true;
    if (isDevMode()) {
    } else {
    }
  }

  /**
   * The ngOnDestroy function checks if a subscription exists and unsubscribes it if it does.
   */
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
